export const getColumnCardsItems = (componentData, getComposePageUrl) => {
    return {
        bgColor: componentData?.fields?.backgroundColour,
        gridSpacing: componentData?.fields?.gridSpacing,
        gridColumns: componentData?.fields?.gridColumns,
        items: componentData?.fields?.elements?.map(e => {
            return {
                id: e?.sys?.id,
                imageTitle: e?.fields?.image?.fields?.title,
                imageUrl: e?.fields?.image?.fields?.file?.url,
                title: e?.fields?.title,
                description: e?.fields?.description,
                links: e?.fields?.ctaLinks?.map(l => {
                    let url = l?.fields?.url;
                    let isContentPageLinked = false;
                    if (l?.fields?.contentPage?.fields?.slug) {
                        isContentPageLinked = true;
                        url = l?.fields?.contentPage?.fields?.slug;
                    }
                    return {
                        label: l?.fields?.label,
                        url: isContentPageLinked ? getComposePageUrl(url) : url,
                        id: l?.fields?.id
                    };
                })
            };
        })
    };
};
